module.exports = __webpack_public_path__ + "media/meow_4.8fbc00db.wav";